<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineProps, defineEmits, watch, ref, onMounted } from 'vue';

    const props = defineProps({
        modelValue: { type: Number, default: null },
        minValue: { type: Number, default: 0 }
    });
    const quantityValue = ref(props.modelValue || props.minValue);
    const emit = defineEmits(['update:modelValue']);

    watch(props, () => {
        if (props.modelValue) {
            quantityValue.value = props.modelValue;
        }
    }, { deep: true });
    
    watch(quantityValue, () => {
        emit('update:modelValue', quantityValue.value);
    }, { deep: true });

    function increment() {
        quantityValue.value += 1;
    }

    function decrement() {
        if (quantityValue.value > props.minValue) {
            quantityValue.value -= 1;
        }
    }
</script>
<template>
    <div class="flex align-items-center">
        <button class="btn xs square black stroke mx-0" @click="decrement">
            <img src="/public/icons/icon-retirer.svg" class="btn-icon" alt="" />
        </button>
        <h6 class="mx-4 px-3 py-2 border-black border-1 rounded-10 text-xs">{{ quantityValue }}</h6>
        <button class="btn xs square black stroke mx-0" @click="increment">
            <img src="/public/icons/icon-ajouter.svg" class="btn-icon" alt="" />
        </button>
    </div>
</template>